/**
 * Image with text: optional button scrolls to the next section's product / collection grid.
 * Activated by anchor[data-scroll-to-product-grid="true"].
 */
(function () {
  function findScrollTargetFromSection(sectionEl) {
    var node = sectionEl.nextElementSibling;
    for (var i = 0; i < 8 && node; i++) {
      var grid =
        node.querySelector('ul.grid.product-grid') ||
        node.querySelector('ul.product-grid') ||
        node.querySelector('ul.collection-list[role="list"]') ||
        node.querySelector('ul.collection-list');
      if (grid) {
        return grid;
      }
      var collectionBlock = node.querySelector('[id^="collection-"]');
      if (collectionBlock) {
        var innerGrid =
          collectionBlock.querySelector('ul.grid.product-grid') ||
          collectionBlock.querySelector('ul.product-grid') ||
          collectionBlock.querySelector('ul.collection-list');
        if (innerGrid) {
          return innerGrid;
        }
        return collectionBlock;
      }
      node = node.nextElementSibling;
    }
    return null;
  }

  document.addEventListener(
    'click',
    function (e) {
      var link = e.target.closest('a[data-scroll-to-product-grid="true"]');
      if (!link) {
        return;
      }
      if (e.defaultPrevented) {
        return;
      }
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
        return;
      }
      var section = link.closest('.shopify-section');
      if (!section) {
        return;
      }
      var target = findScrollTargetFromSection(section);
      if (!target) {
        return;
      }
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    false
  );
})();
